declare const process: any;

/** Ensures that the funtion is only run in development mode */
export const runIfDev = (fn: Function) => {
	if (process.env.NODE_ENV === "development" && fn) {
		fn();
	}
};